export default __webpack_public_path__ + "media/transfer_window/upsell-thisworks-5e96da04.jpg";